import { router } from '@/router'
import { useAdminStore } from '@/stores/admin'
import type DrawerItem from '@/types/DrawerItem'

export const items: DrawerItem[] = [
  {
    title: 'Produtores',
    icon: 'fa-fw fa-solid fa-calendar-circle-user',
    resource: 'producers',
    children: [
      {
        title: 'Listar',
        path: '/producers',
        callback: () => router.push('/producers'),
      },
      {
        title: 'Gerenciar',
        path: '/producers/manage',
        callback: () => router.push('/producers/manage'),
      },
    ],
  },
  {
    title: 'Eventos',
    icon: 'fa-fw fa-solid fa-calendar-days',
    children: [
      {
        title: 'Listar Eventos',
        path: '/events',
        callback: () => router.push('/events'),
        resource: 'events',
        needsProducer: true,
      },
      {
        title: 'Configurações de Evento',
        path: '/event-configurations',
        callback: () => router.push('/event-configurations'),
        resource: 'event-configurations',
        needsProducer: true,
      },
      {
        title: 'Lotes',
        path: '/batches/manage',
        callback: () => router.push('/batches/manage'),
        resource: 'batches',
        needsProducer: true,
      },
      {
        title: 'Cortesias',
        path: '/complimentary-tickets',
        icon: 'fa-fw fa-solid fa-people-group',
        callback: () => router.push('/complimentary-tickets'),
        resource: 'complimentary-tickets',
        needsProducer: true,
      },
    ],
  },
  {
    title: 'Ingressos e Vendas',
    path: '/sales',
    icon: 'fa-fw fa-solid fa-sack-dollar',
    resource: 'sales',
    needsProducer: true,
    children: [
      {
        title: 'Ingressos',
        path: '/sales',
        resource: 'sales',
        needsProducer: true,
        children: [
          {
            title: 'Relatório de Ingressos',
            path: '/reports/sales/list-items',
            callback: () => router.push('/reports/sales/list-items'),
            resource: 'sales.report.ticket-sales',
          },
          {
            title: 'Relatório de Portadores',
            path: '/reports/holders',
            callback: () => router.push('/reports/holders'),
            resource: 'sales.report.holders',
          },
        ],
      },
      {
        title: 'Vendas',
        path: '/sales',
        resource: 'sales',
        needsProducer: true,
        children: [
          {
            title: 'Relatório de Faturamento',
            path: '/reports/event-revenue',
            callback: () => router.push('/reports/event-revenue'),
            resource: 'sales.report.pos',
          },
          {
            title: 'Relatório de Compras',
            path: '/reports/orders',
            callback: () => router.push('/reports/orders'),
            resource: 'sales.report.orders',
          },
          {
            title: 'Relatório de Recebimentos',
            path: '/reports/list-invoices',
            callback: () => router.push('/reports/list-invoices'),
            resource: 'sales.report.invoices',
          },
        ],
      },
    ],
  },
  {
    title: 'Acessos',
    path: '/readings',
    icon: 'fa-fw fa-solid fa-qrcode',
    needsProducer: true,
    children: [
      {
        title: 'Borderô de Acesso',
        path: '/events/overview',
        callback: () => router.push('/events/overview'),
        resource: 'readings.overview',
      },
      {
        title: 'Leitura Detalhada',
        path: '/reports/readings',
        callback: () => router.push('/reports/readings'),
        resource: 'readings.detailed',
      },
      {
        title: 'Check-in de Usuários',
        path: '/check-in',
        callback: () => router.push('/check-in'),
        resource: 'readings.check-in',
      },
      {
        title: 'Controle de Acesso',
        path: '/events/access-control',
        callback: () => router.push('/events/access-control'),
        resource: 'readings.access-control',
      },
    ],
  },
  {
    title: 'Locais e Pontos de Venda',
    path: '/locations',
    icon: 'fa-fw fa-solid fa-location-dot',
    children: [
      {
        title: 'Locais',
        path: '/locations',
        callback: () => router.push('/locations'),
        resource: 'locations',
        children: [
          {
            title: 'Listagem de Locais',
            path: '/locations',
            callback: () => router.push('/locations'),
            resource: 'locations',
            needsProducer: true,
          },
          {
            title: 'Mapeamento de Locais',
            path: '/mappings',
            callback: () => router.push('/mappings'),
            resource: 'mapping-locations',
            needsProducer: true,
          },
        ],
      },
      {
        title: 'Pontos de Venda',
        path: '/points-of-sale',
        icon: 'fa-fw fa-solid fa-store',
        callback: () => router.push('/points-of-sale'),
        resource: 'pos',
        needsProducer: true,
      },
    ],
  },
  {
    title: 'Marketing e Divulgação',
    path: '/banners',
    icon: 'fa-fw fa-solid fa-image',
    children: [
      {
        title: 'Banners',
        path: '/banners',
        resource: 'banners',
        children: [
          {
            title: 'Gerenciar',
            path: '/banners/list',
            callback: () => router.push('/banners/list'),
          },
          {
            title: 'Ordenar',
            path: '/banners/sort',
            callback: () => router.push('/banners/sort'),
            requiredAbilities: [ 'sort.banners' ],
          },
        ],
      },
      {
        title: 'Promoters',
        path: '/affiliates',
        resource: 'affiliates',
        needsProducer: true,
        children: [
          {
            title: 'Gerenciar',
            path: '/affiliates',
            callback: () => router.push('/affiliates'),
          },
          {
            title: 'Credenciar',
            path: '/affiliates/events',
            callback: () => router.push('/affiliates/events'),
          },
          {
            title: 'Ativações',
            path: '/affiliates/sales',
            callback: () => router.push('/affiliates/sales'),
          },
        ],
      },
    ],
  },
  {
    title: 'Recursos Extras',
    path: '/coupons',
    icon: 'fa-fw fa-solid fa-badge-percent',
    children: [
      {
        title: 'Cupons',
        path: '/coupons',
        callback: () => router.push('/client-data'),
        resource: 'coupons',
        needsProducer: true,
      },
      {
        title: 'Pré Impressão',
        path: '/pre-print',
        callback: () => router.push('/client-data'),
        resource: 'pre-print',
        needsProducer: true,
      },
    ],
  },
  {
    title: 'Usuários e Administraćão',
    path: '/users',
    icon: 'fa-fw fa-regular fa-user-tag',
    children: [
      {
        title: 'Clientes',
        path: '/users',
        callback: () => router.push('/users'),
        resource: 'users',
      },
      {
        title: 'Administradores',
        path: '/admins',
        callback: () => router.push('/admins'),
        resource: 'admins',
      },
      // {
      //   title: 'Cargos',
      //   path: '/roles',
      //   callback: () => router.push('/roles'),
      //   resource: 'roles',
      // },
    ],
  },
  {
    title: 'Sair',
    icon: 'fa-fw fa-solid fa-arrow-right-from-bracket',
    callback: () => {
      useAdminStore().logout()
      router.push('/login')
    },
    path: '/logout',
  },
]
